import { logoutSuccess } from 'features/auth/redux/actions';
import { GET_PLANS_DETAILS, SET_IS_LOADING, SET_SUBSCRIPTION_PLAN } from './types';
import { PlansData } from 'features/subscription/ts/SubscriptionPlans';

export const loadingSubscriptionPlansAction = (value: boolean) => ({
  type: SET_IS_LOADING,
  payload: value,
});

export const requestGetSubscriptionPlansAction = (plans: PlansData[]) => ({
  type: GET_PLANS_DETAILS,
  payload: plans,
});

export const setSelectedSubscriptionPlansAction = (payload: string) => ({
  type: SET_SUBSCRIPTION_PLAN,
  payload: payload,
});

export type SubscriptionPlansData = ReturnType<
  | typeof logoutSuccess
  | typeof requestGetSubscriptionPlansAction
  | typeof loadingSubscriptionPlansAction
  | typeof setSelectedSubscriptionPlansAction
>;
